import Dialog from "../1. Core/Controls/Dialog/Dialog";
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import {IBattleEvent} from "../10. Battle/Util";
import Button from "../1. Core/Controls/Button/Button";
import Label from "../1. Core/Controls/Label/Label";
import CheckBox from "../1. Core/Controls/CheckBox/CheckBox";
import Menu from "../1. Core/Controls/Menu/Menu";
import ListBox from "../1. Core/Controls/ListBox/ListBox";
import UserInfo, {IUserInfo} from "../1. Core/UserInfo";

export const TimeSegments = ['0:00 - 0:30', '0:30 - 1:00', '1:00 - 1:30', '1:30 - 2:00', '2:00 - 2:30', '2:30 - 3:00'];
export const getTimeSegmentIndexByValue = (value: number) =>
{
	if (value <= 30)
		return 0;
	if (value <= 60)
		return 1;
	if (value <= 90)
		return 2;
	if (value <= 120)
		return 3;
	if (value <= 150)
		return 4;
	if (value <= 180)
		return 5;
};
export const getTimeSegmentValueByIndex = (timeSegmentIndex: number) =>
{
	return (timeSegmentIndex + 1) * 30
};

export default class BattleStatisticsDialogBase extends Dialog {
	protected _CheckEditLockTimer: number;
	protected _BattleId: number;
	protected _TournamentId: number;
	protected _MaxRound: number;
	protected _Tournament: string;
	protected _Stage: string;
	protected _Round: number;
	protected _LastEditedRound: number;
	protected _TimeSegmentIndex: number;
	protected _LastEditedTimeSegmentIndex: number;
	protected _Sequence: number;
	protected _IsActionInSequence: boolean;
	protected _RedName: string;
	protected _BlueName: string;
	protected _Red: number;
	protected _Blue: number;
	protected _DialogMode: number; // 0 - strike, 1 - answer, 2 - hit reg
	protected _ActiveStrikeButton: Button;
	protected _ActiveAnswerButton: Button;
	protected _ActionAthleteId: number;
	protected _AnswerAthleteId: number;
	protected _Action: string;
	protected _Answer: string;
	protected _CurrentBattleEvents: IBattleEvent[]; //события текущего отрезка времени, при очередном сохранении в БД их следует полностью перезаписывать, чтобы была возможность произвольно откатывать/добавлять события в пределах отрезка
	protected _AllBattleEvents: IBattleEvent[]; //события всего боя, применяется чтобы при просмотре сохраненных отрезков не обращаться к серверу

	protected _historyNode: HTMLElement;


	protected _redLabel: Label;
	protected _blueLabel: Label;
	protected _roundLabel: Label;
	protected _timeSegmentLabel: Label;
	protected _sequenceLabel: Label;

	protected _strikeRed: HTMLElement;

	protected _redHLBtn: Button;
	protected _redHRBtn: Button;
	protected _redULBtn: Button;
	protected _redURBtn: Button;
	protected _redCLBtn: Button;

	protected _strikeBlue: HTMLElement;

	protected _blueHLBtn: Button;
	protected _blueHRBtn: Button;
	protected _blueULBtn: Button;
	protected _blueURBtn: Button;
	protected _blueCLBtn: Button;

	protected _answerRed: HTMLElement;


	protected _redJBtn: Button;
	protected _redCBtn: Button;

	protected _redBBtn: Button;
	protected _blueBBtn: Button;

	protected _blueJBtn: Button;
	protected _blueCBtn: Button;


	protected _redNBtn: Button;
	protected _redUBtn: Button;
	protected _redWBtn: Button;
	protected _redPBtn: Button;

	protected _answerBlue: HTMLElement;

	protected _blueNBtn: Button;
	protected _blueUBtn: Button;
	protected _blueWBtn: Button;
	protected _bluePBtn: Button;

	protected _hitRed: HTMLElement;
	protected _redP1Btn: Button;
	protected _redP2Btn: Button;
	protected _redP3Btn: Button;
	protected _redP4Btn: Button;
	protected _redP5Btn: Button;
	protected _redP6Btn: Button;
	protected _redP7Btn: Button;

	protected _hitBlue: HTMLElement;
	protected _blueP1Btn: Button;
	protected _blueP2Btn: Button;
	protected _blueP3Btn: Button;
	protected _blueP4Btn: Button;
	protected _blueP5Btn: Button;
	protected _blueP6Btn: Button;
	protected _blueP7Btn: Button;

	protected _blueKnockdownBtn: CheckBox;

	protected _spaceBtn: Button;


	protected _backBtn: Button;
	protected _nextTimeSegmentBtn: Button;
	protected _nextRoundBtn: Button;
	protected _boutEndBtn: Button;
	protected _overviewBtn: Button;

	protected _redKnockdownBtn: CheckBox;
	protected _blueStunningBtn: CheckBox;
	protected _redStunningBtn: CheckBox;
	protected _redrightJBtn: Button;
	protected _redleftCBtn: Button;
	protected _redleftJBtn: Button;
	protected _redrightC: Button;
	protected _blueleftJBtn: Button;
	protected _bluerightJBtn: Button;
	protected _blueleftCBtn: Button;
	protected _bluerightCBtn: Button;
	protected _redleftBBtn: Button;
	protected _redcenterBBtn: Button;
	protected _redrightBBtn: Button;
	protected _blueleftBBtn: Button;
	protected _bluecenterBBtn: Button;
	protected _bluerightBBtn: Button;


	_initFields(settings: object)
	{
		this._BattleId = null;
		this._CheckEditLockTimer = null;
		super._initFields(settings);
	}

	createCriticalCB(eventInfoLeftSection: HTMLElement, eventInfoRightSection: HTMLElement)
	{
		this._redKnockdownBtn = new CheckBox({
			Content: NP.RM.getString('Knockdown'),
			Value: 'Knockdown',
			ParentNode: eventInfoLeftSection,
			EvCheckedChanged: () => this._redStunningBtn.setEnabled(!this._redKnockdownBtn.getChecked())
		});

		this._redStunningBtn = new CheckBox({
			Content: NP.RM.getString('CriticalPunch'),
			Value: 'CriticalPunch',
			ParentNode: eventInfoLeftSection,
			EvCheckedChanged: () => this._redKnockdownBtn.setEnabled(!this._redStunningBtn.getChecked())
		});

		this._blueKnockdownBtn = new CheckBox({
			Content: NP.RM.getString('Knockdown'),
			Value: 'Knockdown',
			ParentNode: eventInfoRightSection,
			EvCheckedChanged: () => this._blueStunningBtn.setEnabled(!this._blueKnockdownBtn.getChecked())
		});

		this._blueStunningBtn = new CheckBox({
			Content: NP.RM.getString('CriticalPunch'),
			Value: 'CriticalPunch',
			ParentNode: eventInfoRightSection,
			EvCheckedChanged: () => this._blueKnockdownBtn.setEnabled(!this._blueStunningBtn.getChecked())
		});
	}

	showBlockDialog = (blockerSettings: IUserInfo): boolean =>
	{

		if (!blockerSettings)
			return false;

		let blocker: UserInfo = new UserInfo(blockerSettings);
		let curUser = NP.getCurrentUser();
		let isYou = curUser.getKey() === blocker.getKey();
		let emailPart = !isYou ? NP.escapeHTML(`<${blocker.getEmail()}>`) : '';
		let unlockPart = isYou ? `<br />${NP.RM.getString('UnlockQuestion')}` : '';
		let dlg = new Dialog({
			ShowHeader: true,
			Caption: NP.RM.getString('Error'),
			Content: `${NP.RM.getString('BattleLockMessage')}${blocker.getViewName()}${emailPart}${unlockPart}`,
			AutoDestroy: true,
			ShowButtons: true,
			EvOkButtonClick: isYou ? this.onBlockDialogOkButtonClick : undefined,
		});
		if (!isYou)
			dlg.getCancelButton().setIsVisible(false);
		dlg.show();
		return true;
	};

	onBlockDialogOkButtonClick = () =>
	{
		ServerAPI.post(`/battle/${this._BattleId}/endEditBattleData`).then(() =>
		{
			NP.editingBattleId = null;
			this.show();
		});
		window.clearInterval(this._CheckEditLockTimer);
	};

	show()
	{
		// NP.ServerAPI.call("SportService.startEditBattleData", [this._BattleId]).then((blocker: IUserInfo) =>
		// {
		// 	if (this.showBlockDialog(blocker))
		// 		return;
		//
		// 	NP.editingBattleId = this._BattleId;
		// 	const checkInterval = 10000;
		// 	super.show();
		// 	if (this._CheckEditLockTimer != null)
		// 		window.clearInterval(this._CheckEditLockTimer);
		// 	this._CheckEditLockTimer = window.setInterval(() =>
		// 	{
		// 		NP.ServerAPI.call("SportService.checkIsBattleDataLocked", [this._BattleId]).then((isLocked: boolean) =>
		// 		{
		// 			if (!isLocked)
		// 			{
		// 				NP.ServerAPI.call("SportService.startEditBattleData", [this._BattleId]);
		// 			}
		// 		});
		// 	}, checkInterval);
		//
		// 	this._restoreData();
		// });

		super.show();
		this._restoreData();
	}

	// hide()
	// {
	// 	NP.ServerAPI.call("SportService.endEditBattleData", [this._BattleId]).then(() =>
	// 	{
	// 		NP.editingBattleId = null;
	// 	});
	// 	window.clearInterval(this._CheckEditLockTimer);
	// 	super.hide();
	// }

	refresh()
	{

	}

	//восстановить последний сохраненный раунд, отрезок времени
	_restoreData()
	{
		ServerAPI.get(`/box/getBattleEvents/${this._BattleId}`).then((res: IBattleEvent[]) =>
		{
			if (res.length > 0)
			{
				this._AllBattleEvents = res;
				this._Round = res[0].Round;
				this._TimeSegmentIndex = getTimeSegmentIndexByValue(res[0].TimeSegment);

				if (this._TimeSegmentIndex >= TimeSegments.length - 1) //если сохраненный временной отрезок последний в раунде - значит начался следующий раунд
				{
					if (this._Round < this._MaxRound)
					{
						this._Round += 1;
						this._TimeSegmentIndex = 0;
					}
				}
				else //если сохраненный временной отрезок не последний - начать со следующего отрезка
				{
					this._TimeSegmentIndex += 1;
				}

				this._LastEditedRound = this._Round;
				this._LastEditedTimeSegmentIndex = this._TimeSegmentIndex;

				this.setCaption(NP.RM.getString('BattleStatistics') + " (" + res.length + " " + NP.RM.getString('Records') + ")");
			}


			NP.showNode(this._contentNode);
			this._clearHistory();
			this._setStrikeMode();
		});
	}

	_restoreTimeSegment(round: number, timeSegment: number)
	{
		if (round && timeSegment)
		{
			this._Round = round;
			this._TimeSegmentIndex = getTimeSegmentIndexByValue(timeSegment);
			this._CurrentBattleEvents = [];
			this._clearHistory();
			this._applyBattleEvents(this._AllBattleEvents
				 .filter(el => el.Round == this._Round && el.TimeSegment == timeSegment)
				 .sort((a, b) => a.Sequence - b.Sequence));
			this._setStrikeMode();
		}
	}

	_applyBattleEvents(battleEvents: IBattleEvent[])
	{
		this._Sequence = 1;
		let currentSequence = this._Sequence;
		battleEvents.forEach(battleEvent =>
		{
			this._Action = battleEvent.Action;
			this._Answer = battleEvent.Answer;
			this._ActionAthleteId = battleEvent.ActionAthleteId;
			this._AnswerAthleteId = battleEvent.AnswerAthleteId;
			if (battleEvent.Sequence > currentSequence)
			{
				this._applySpace();
				currentSequence = this._Sequence;
			}
			this._applyBattleEvent({});
		});

		if (this._CurrentBattleEvents.length > 0 && this._CurrentBattleEvents[this._CurrentBattleEvents.length - 1].Answer == 'CL')
			this._applySpace();
	}

	_applyBattleEvent(args: { Action?: string, Answer?: string, SetNextSequence?: boolean, SkipInHistory?: boolean })
	{
		if (args.Action)
			this._Action = args.Action;

		if (args.Answer)
			this._Answer = args.Answer;

		this._CurrentBattleEvents.push({
			BattleId: this._BattleId,
			Round: this._Round,
			Sequence: this._Sequence,
			ActionAthleteId: this._ActionAthleteId,
			AnswerAthleteId: this._AnswerAthleteId,
			TimeSegment: getTimeSegmentValueByIndex(this._TimeSegmentIndex),
			Action: this._Action,
			Answer: this._Answer
		});

		let lastEvent;
		if (!args.SkipInHistory)
			lastEvent = this._displayBattleEventInHistory();

		if (args.SetNextSequence)
			this._applySpace();
		else
			this._IsActionInSequence = true;


		if (this._Answer.startsWith("P") && (this._blueKnockdownBtn.getChecked() || this._redKnockdownBtn.getChecked()))
		{
			this._CurrentBattleEvents.push({
				BattleId: this._BattleId,
				Round: this._Round,
				Sequence: this._Sequence,
				ActionAthleteId: this._ActionAthleteId,
				AnswerAthleteId: this._AnswerAthleteId,
				TimeSegment: getTimeSegmentValueByIndex(this._TimeSegmentIndex),
				Action: null,
				Answer: "Knockdown"
			});

			if (lastEvent)
			{
				if (this._AnswerAthleteId == this._Red)
					lastEvent[0].innerText = "•" + lastEvent[0].innerText;
				else
					lastEvent[1].innerText = lastEvent[1].innerText + "•";
			}
		}

		if (this._Answer.startsWith("P") && (this._blueStunningBtn.getChecked() || this._redStunningBtn.getChecked()))
		{
			this._CurrentBattleEvents.push({
				BattleId: this._BattleId,
				Round: this._Round,
				Sequence: this._Sequence,
				ActionAthleteId: this._ActionAthleteId,
				AnswerAthleteId: this._AnswerAthleteId,
				TimeSegment: getTimeSegmentValueByIndex(this._TimeSegmentIndex),
				Action: null,
				Answer: "CriticalPunch"
			});

			if (lastEvent)
			{
				if (this._AnswerAthleteId == this._Red)
					lastEvent[0].innerText = "(C)" + lastEvent[0].innerText;
				else
					lastEvent[1].innerText = lastEvent[1].innerText + "(C)";
			}
		}

		this._setStrikeMode();
	}

	_rollBackBattleEvent()
	{
		if (this._CurrentBattleEvents.pop().Sequence == null) //если откатываем пробел, значит возврат в предыдущую серию, в которой есть действия
		{
			this._IsActionInSequence = true;
			this._Sequence -= this._Sequence == 1 ? 0 : 1;
		}
		else
		{
			this._IsActionInSequence = this._CurrentBattleEvents.length > 0
		}

		if (this._historyNode.lastChild)
			this._historyNode.removeChild(this._historyNode.lastChild);

		this._setStrikeMode();
	}

	_applySpace(saveToDB?: boolean)
	{
		this._IsActionInSequence = false;

		//пробелы нужно сохранять, чтобы массив и отображаемая история изменялись синхронно, при сохранении на сервер пробелы нужно отфильтровать
		this._CurrentBattleEvents.push({
			BattleId: this._BattleId,
			Round: this._Round,
			Sequence: null,
			ActionAthleteId: null,
			AnswerAthleteId: null,
			TimeSegment: getTimeSegmentValueByIndex(this._TimeSegmentIndex),
			Action: null,
			Answer: null
		});

		if (saveToDB)
			ServerAPI.post("/box/editBattleEvents", this._CurrentBattleEvents.filter(ev => ev.Sequence != null)).then(() =>
			{
				this._writeCurrentBattleEventsToAllBattleEvents();

				this._displaySequenceEndInHistory();
				this._Sequence += 1;

				this._refreshHeader();
				this._updateActionButtonsEnabled();
			});
		else
		{
			this._displaySequenceEndInHistory();
			this._Sequence += 1;

			this._refreshHeader();
			this._updateActionButtonsEnabled();
		}
	}

	_displayBattleEventInHistory()
	{
		let row = NP.createNode(this._historyNode, 'events-history__row', null),
			 redEvent = NP.createNode(row, 'events-history__row__item'),
			 blueEvent = NP.createNode(row, 'events-history__row__item');

		let an = this._Answer.startsWith("P") ? NP.RM.getString(this._Answer + "Short") : NP.RM.getString(this._Answer);

		redEvent.innerText = this._ActionAthleteId == this._Red ? NP.RM.getString(this._Action) : an;
		blueEvent.innerText = this._ActionAthleteId == this._Blue ? NP.RM.getString(this._Action) : an;
		this._historyNode.scrollTop = this._historyNode.scrollHeight;

		return [redEvent, blueEvent];
	}

	_displaySequenceEndInHistory()
	{
		let row = NP.createNode(this._historyNode, 'events-history__row', null),
			 endSequence = NP.createNode(row, 'events-history__row__item');
		endSequence.innerHTML = '-- ' + this._Sequence + ' --';
		this._historyNode.scrollTop = this._historyNode.scrollHeight;
	}

	_setClinchAction(answerAthleteId: number)
	{
		this._AnswerAthleteId = answerAthleteId;
		this._ActionAthleteId = answerAthleteId == this._Red ? this._Blue : this._Red;
		this._Action = '';
		this._Answer = this._blueCLBtn.getValue();
	}

	_openOverview()
	{
		if (this._AllBattleEvents.length > 0)
		{
			let roundTimeSegments: { Round: number, TimeSegment: number }[] = [];
			this._AllBattleEvents.forEach(battleEvent =>
			{
				let roundTimeSegment = {Round: battleEvent.Round, TimeSegment: battleEvent.TimeSegment};
				if (roundTimeSegments.findIndex(el => el.Round == roundTimeSegment.Round && el.TimeSegment == roundTimeSegment.TimeSegment) == -1)
					roundTimeSegments.push(roundTimeSegment);
			});

			let dropPanel = new Menu({
				EvItemSelected: (s: ListBox, args: any) => this._restoreTimeSegment(args.Item.getValue().Round, args.Item.getValue().TimeSegment)
			});
			dropPanel.addItems(roundTimeSegments
				 .sort((a, b) => b.Round - a.Round || b.TimeSegment - a.TimeSegment)
				 .map((roundTimeSegment: { Round: number, TimeSegment: number }) =>
					  {
						  return {
							  Value: roundTimeSegment,
							  Content: NP.RM.getString('Round') + ': ' + roundTimeSegment.Round + ' ' + NP.RM.getString('TimeSegment') + ': ' + TimeSegments[getTimeSegmentIndexByValue(roundTimeSegment.TimeSegment)],
						  }
					  }
				 ));
			NP.showDropPanel(dropPanel, this._overviewBtn.getRoot(), NP.LTRB.Top, true, true);
		}
	}

	_clearHistory()
	{
		this._historyNode.innerHTML = '';
	}

	_refreshHeader()
	{
		this._roundLabel.setContent(NP.RM.getString('Round') + ' ' + this._Round);
		this._timeSegmentLabel.setContent(NP.RM.getString('TimeSegment') + ' ' + TimeSegments[this._TimeSegmentIndex]);
		this._sequenceLabel.setContent(NP.RM.getString('StrikesSequence') + ' ' + this._Sequence);
	}

	_setStrikeMode()
	{
		this._DialogMode = 0;
		this._AnswerAthleteId = null;
		this._ActionAthleteId = null;

		this._blueKnockdownBtn.setChecked(false);
		this._blueStunningBtn.setChecked(false);
		this._redKnockdownBtn.setChecked(false);
		this._redStunningBtn.setChecked(false);

		NP.hide([this._answerRed, this._answerBlue, this._hitRed, this._hitBlue, this._redKnockdownBtn, this._blueKnockdownBtn, this._redStunningBtn, this._blueStunningBtn]);
		NP.show([this._strikeRed, this._strikeBlue, this._spaceBtn]);
		NP.setEnabled([this._redleftJBtn, this._redrightJBtn, this._redleftCBtn, this._redrightC, this._redHLBtn, this._redHRBtn, this._redULBtn, this._redURBtn, this._redCLBtn,
			this._blueJBtn, this._blueCBtn, this._redJBtn, this._redCBtn,
			this._blueKnockdownBtn, this._blueStunningBtn, this._redKnockdownBtn, this._redStunningBtn,
			this._blueleftJBtn, this._bluerightJBtn, this._blueleftCBtn, this._bluerightCBtn, this._blueHLBtn, this._blueHRBtn, this._blueULBtn, this._blueURBtn, this._blueCLBtn, this._boutEndBtn], true);

		this._refreshHeader();
		this._updateActionButtonsEnabled();
	}

	_updateActionButtonsEnabled()
	{
		this._nextTimeSegmentBtn.setEnabled((this._IsActionInSequence || this._Sequence > 1) && this._TimeSegmentIndex < TimeSegments.length - 1);
		this._nextRoundBtn.setEnabled((this._IsActionInSequence || this._Sequence > 1) && this._Round < this._MaxRound && this._TimeSegmentIndex >= TimeSegments.length - 1);
		this._backBtn.setEnabled(this._CurrentBattleEvents.length > 0);
		this._spaceBtn.setEnabled(this._IsActionInSequence);
	}

	_setNextRound()
	{
		if (this._CurrentBattleEvents.length > 0)
		{
			ServerAPI.post("/box/editBattleEvents", this._CurrentBattleEvents.filter(ev => ev.Sequence != null)).then(() =>
			{
				this._writeCurrentBattleEventsToAllBattleEvents(true);
				this._historyNode.innerHTML = '';
				this._IsActionInSequence = false;

				if (this._Round < this._LastEditedRound)
				{
					this._Round = this._LastEditedRound;
					this._TimeSegmentIndex = this._LastEditedTimeSegmentIndex;
				}
				else
				{
					this._Round += 1;
					this._LastEditedRound = this._Round;
					this._TimeSegmentIndex = 0;
					this._LastEditedTimeSegmentIndex = this._TimeSegmentIndex;
				}

				this._resetSequence();
				this._refreshHeader();
				this._updateActionButtonsEnabled();
			});
		}
	}

	_setNextTimeSegment()
	{
		if (this._CurrentBattleEvents.length > 0)
		{
			ServerAPI.post("/box/editBattleEvents", this._CurrentBattleEvents.filter(ev => ev.Sequence != null)).then(() =>
			{
				this._writeCurrentBattleEventsToAllBattleEvents(true);
				this._historyNode.innerHTML = '';
				this._IsActionInSequence = false;

				if (this._Round < this._LastEditedRound)
				{
					this._Round = this._LastEditedRound;
					this._TimeSegmentIndex = this._LastEditedTimeSegmentIndex;
				}
				else if (this._TimeSegmentIndex < this._LastEditedTimeSegmentIndex)
				{
					this._TimeSegmentIndex = this._LastEditedTimeSegmentIndex;
				}
				else
				{
					this._TimeSegmentIndex += 1;
					this._LastEditedTimeSegmentIndex = this._TimeSegmentIndex;
				}

				this._restoreTimeSegment(this._Round, getTimeSegmentValueByIndex(this._TimeSegmentIndex));
				this._refreshHeader();
				this._updateActionButtonsEnabled();
			});
		}
	}

	_writeCurrentBattleEventsToAllBattleEvents(clearCurrentEvents?: boolean)
	{
		//удалить ранее сохраненные события текущего отрезка из событий боя
		while (this._AllBattleEvents.findIndex(ev => ev.Round == this._Round && ev.TimeSegment == getTimeSegmentValueByIndex(this._TimeSegmentIndex)) != -1)
			this._AllBattleEvents.splice(this._AllBattleEvents.findIndex(ev => ev.Round == this._Round && ev.TimeSegment == getTimeSegmentValueByIndex(this._TimeSegmentIndex)), 1);

		//добавить новые события текущего отрезка в события боя
		this._CurrentBattleEvents
			 .filter(el => el.Sequence != null)
			 .forEach(el => this._AllBattleEvents.push(el));

		if (clearCurrentEvents)
			this._CurrentBattleEvents = [];
	}

	_resetSequence()
	{
		this._IsActionInSequence = false;
		this._Sequence = 1;
		this._refreshHeader();
		this._updateActionButtonsEnabled();
	}

	_setBoutEnd()
	{
		ServerAPI.post("/box/editBattleEvents", this._CurrentBattleEvents.filter(ev => ev.Sequence != null)).then(() =>
		{
			//ServerAPI.call("BoxDataService.refreshBattleSeries");
			NP.showMessage({RK: 'Done'});
			this.hide();
		});
	}

	_onBackClick()
	{
		if (this._DialogMode > 0)
			this._setStrikeMode();
		else
			this._rollBackBattleEvent();
	}

	_onCancelButtonClick()
	{
		if (this._CurrentBattleEvents.length > 0)
			NP.showConfirm({
				Content: NP.RM.getString('CloseBattleStatisticsConf'),
				EvOkButtonClick: () =>
				{
					super._onCancelButtonClick();
				}
			});
		else
			super._onCancelButtonClick();
	}
}